Auth = require 'db/auth'
BoardsSidebarSectionView = require 'views/boards-sidebar/boards-sidebar-section-view'
ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
SidebarState = require 'view-models/sidebar-state'
_ = require 'underscore'
l = require 'lib/localize'
ninvoke = require 'lib/util/ninvoke'
ApiError = require 'network/api-error'
RecentBoards = require 'lib/recent-boards'
recentBoardsHelper = new RecentBoards()

_idBoardsFetching = []

module.exports = class BoardsSidebarRecentSectionView extends BoardsSidebarSectionView
  initialize: ->
    super

    @listenTo SidebarState, 'change:idRecentBoards', ->
      @debouncedRenderBoards()

    @listenTo @model.boardStarList, 'add remove reset', ->
      @debouncedRenderBoards()

  sectionId: -> "recent-boards"

  sectionName: -> "Recent Boards"

  showOrgName: -> true

  isRecent: -> true

  getBoards: ->
    recentBoardsHelper.getBoards(@model, @debouncedRenderBoards.bind(@)).slice(0, 8)

  getHeaderInfo: ->
    {
      title: l('board section title.recent boards')
      iconClass: 'clock'
    }



// WEBPACK FOOTER //
// ./app/scripts/views/boards-sidebar/boards-sidebar-recent-section-view.coffee